/* eslint-disable no-unused-vars */

import React, { useContext } from 'react';
import { Context } from '../Context/withContext';
import { PathContext } from '../PathContext/PathContext';

const LandingSection = () => {
  const [stepNumber, setStepNumber] = useContext(Context);
  const [path, setPath] = useContext(PathContext);

  return (
    <div className="md:py-4 py-12 flex flex-col md:flex-row justify-center items-center">
      <div className="md:w-1/2 py-12 md:border-r md:px-16 border-suzGreen">
        <p className="md:text-5xl text-3xl text-white font-medium tracking-wider">
          I want to own a Suzuki, I am just not sure which one I can afford
          <span className="text-suzGreen">.</span>
        </p>
        <button
          className="bg-suzGreen text-black uppercase px-12 py-4 mt-8"
          onClick={() => {
            setPath('a');
            setStepNumber(1);
          }}
        >
          Find my Suzuki
        </button>
      </div>
      <div className="md:w-1/2 py-12 border-suzGreen md:px-16">
        <p className="md:text-5xl text-3xl text-white font-medium tracking-wider">
          I know exactly which Suzuki is the car of my dreams
          <span className="text-suzGreen">.</span>
        </p>
        <button
          className="bg-suzGreen text-black uppercase px-12 py-4 mt-8"
          onClick={() => {
            setPath('v');
            setStepNumber(1);
          }}
        >
          Apply for finance
        </button>
      </div>
    </div>
  );
};

export default LandingSection;
